document.addEventListener('chatlio.collapsed', () => {
  const path = location.pathname
  if (
    path.startsWith('/login')
    || path.startsWith('/assessment')
    || path.startsWith('/peer-assessment')
    || path.startsWith('/onboarding')
    || path.startsWith('/v2/onboarding')
    || path.startsWith('/users')
  ) return

  if (typeof window !== 'undefined' && window._chatlio && window._chatlio.hide) {
    window._chatlio.hide()
  }
})
